import { useLazyQuery } from "@apollo/client";
import { useContext } from "react";
import { UserContext } from "../common/auth/UserContext";
import { FETCH_POLICY_CONFIG } from "../common/constants/constants";
import { detailsQuery, client } from "./organization";
import { useI18n } from "../common/i18n/I18n";

export const useGetOrganizationDetailsLazily = () => {
    const { activeOrganizationAccount } = useContext(UserContext);
    const fetchError = useI18n('organization.fetch.error');

    const [getOrganizationDetailInfo, { loading: organizationDetailLoading }] = useLazyQuery(detailsQuery, {
        client,
        context: { headers: { ownerId: activeOrganizationAccount } },
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy
    });

    const getOrganizationDetail = async (id: string) => {
        const response = await  getOrganizationDetailInfo({
            variables: {
                id
            }
        })

        if(response.error) {
            throw new Error(fetchError);
        }

        return response.data?.organization;
    };

    return { getOrganizationDetail, organizationDetailLoading };
};